import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContentModel } from '../models/content.model';

@Injectable({ providedIn: 'root' })
export class PlaybackService {
  private readonly playlistSubject = new BehaviorSubject<ContentModel[]>([]);

  readonly playlist$ = this.playlistSubject.asObservable();

  get playlist(): ContentModel[] {
    return this.playlistSubject.value;
  }

  setPlaylist(playlist: ContentModel[]) {
    this.playlistSubject.next(playlist || []);
  }
}
